import { createListenerMiddleware } from '@reduxjs/toolkit';

import { authApi } from '~services/api/auth';
import {
	DatadogLogger,
	LoggerMessages,
	LoggerServices,
} from '~shared/services/logger';
import {
	ImagePerformanceQueryParamKey,
	ImagePerformanceQueryParamValue,
} from '~utils/performance-logging';

export const imageLoadingTrackingInit = createListenerMiddleware();

imageLoadingTrackingInit.startListening({
	matcher: authApi.endpoints.authenticate.matchFulfilled,
	effect: () => {
		if ('serviceWorker' in navigator) {
			navigator.serviceWorker
				.register('/image-loading-tracking-sw.js')
				.then((registration) => {
					// eslint-disable-next-line no-console
					console.log(
						'image-loading Service Worker registered with scope:',
						registration.scope
					);

					registration?.active?.postMessage({
						key: ImagePerformanceQueryParamKey,
						value: ImagePerformanceQueryParamValue,
					});

					navigator.serviceWorker.addEventListener(
						'message',
						(event: {
							data?: { isError: boolean; requestUrl: string; time: number };
						}) => {
							if (event && event.data) {
								const isError = event.data.isError;
								const requestUrl =
									event.data.requestUrl.split('url=')[1] ||
									event.data.requestUrl;
								const time = event.data.time;
								let decodedUrl = requestUrl;
								try {
									decodedUrl = decodeURIComponent(requestUrl);
								} catch (e) {}
								DatadogLogger.info(
									LoggerServices.ImageLoader,
									LoggerMessages.ImageLoadingTime,
									{ isError, requestUrl: decodedUrl, time }
								);
							}
						}
					);
				})
				.catch((error) => {
					// eslint-disable-next-line no-console
					console.error(
						'image-loading Service Worker registration failed:',
						error
					);
				});
		}
	},
});
